/* ═══════════════════════════════════════════════════════════════════════
   Landings de campaña de Core Medical — el único guion de la página.

   Hace tres cosas:
     1. El acordeón del FAQ es EXCLUSIVO: abrir una cierra la anterior.
     2. Recuerda el `gclid` y la `utm_campaign` de la visita.
     3. Cuenta el clic de WhatsApp en GA4 y en Meta, con los MISMOS
        nombres de evento que `landing-camas` y `landing-sillas`.

   ─────────────────────────────────────────────────────────────────────
   LO QUE ESTE GUION NO HACE, Y ES LO MÁS IMPORTANTE
   ─────────────────────────────────────────────────────────────────────
   NO calcula la marca de origen ni la escribe en el mensaje.

   Las otras dos landings sí lo hacen porque están solas en su dominio.
   Ésta vive DENTRO de la tienda, y ahí el trabajo ya está hecho por dos
   guiones del tema que corren antes: `theme.liquid` pega `#cm-<marca>` al
   cargar y `snippets/core-atribucion.liquid` arma la forma final —marca
   más `[Ref CM-…]`— reescribiendo el `href` en el clic.

   Si aquí hubiera una segunda definición de `deLaURL()`, habría DOS
   vocabularios en la misma página y el ERP leería el primer `#cm-` que
   encontrara: la misma campaña saldría partida en dos filas del tablero
   de Marketing, que es exactamente lo que la regla de «todos los sitios
   dicen lo mismo» existe para evitar. Así que la marca aquí se LEE, no se
   calcula, y se lee de donde la dejó el tema.

   Y TAMPOCO manda la conversión a Google Ads. Ésa también es del tema:
   `core-atribucion.liquid` escucha el clic sobre cualquier `wa.me` de la
   tienda, carga gtag con la cuenta de la casa y dispara
   `gtag('event','conversion', …)` él mismo. Las otras dos landings sí la
   mandan porque allí no hay nadie más que lo haga; aquí, mandarla otra vez
   contaría CADA CLIC DOS VECES en Google Ads —y una campaña que cree que
   convierte el doble puja el doble—. Medido: con las dos, el clic salía
   con dos eventos `conversion`.

   Lo que sí falta y por eso está aquí: los eventos de GA4 —que dicen de
   QUÉ SECCIÓN salió el clic— y el `Lead` de Meta. El tema no manda
   ninguno de los dos.

   Por lo mismo NO hay `preventDefault()` ni `window.open()`: si esta
   página abriera el enlace por su cuenta, se abriría el `href` SIN marcar
   —el del tema se escribe en el clic, no antes— y la conversación
   llegaría al ERP sin origen, sin ningún error a la vista. El 02/09/2026
   ya se perdió el origen de una clienta por un fallo de esta familia.
   ═══════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* CADA sección de la landing pide este archivo —dieciocho en el sillón—,
     así que el navegador lo EJECUTA una vez por sección aunque lo descargue
     una sola. Sin este cerrojo, un clic mandaría dieciocho eventos a cada
     plataforma. */
  if (window.__cmLanding) return;
  window.__cmLanding = true;

  var C = window.CM_CONFIG || {};
  function valido(id) { return !!id && id.indexOf('XXXX') === -1; }

  /* ── Lo que se recuerda entre visitas ─────────────────────────────
     Cookie primero y localStorage de repuesto, igual que en las otras
     landings: en el navegador de dentro de Instagram o en una ventana
     privada el almacenamiento puede estar bloqueado, y entonces la
     cookie es lo único que queda. El `\s*` va escapado porque dentro de
     una cadena «\s» es una «s» pelada, y así el patrón no encontraba
     ninguna cookie que no fuera la primera. */
  function param(n) { return new URLSearchParams(location.search).get(n); }
  function guardar(k, v) {
    try {
      document.cookie = k + '=' + encodeURIComponent(v) + ';path=/;max-age=7776000;SameSite=Lax';
      localStorage.setItem(k, v);
    } catch (e) {}
  }
  function leer(k) {
    var m = document.cookie.match('(^|;)\\s*' + k + '=([^;]*)');
    if (m) return decodeURIComponent(m[2]);
    try { return localStorage.getItem(k) || ''; } catch (e) { return ''; }
  }

  var gclid = param('gclid') || param('wbraid') || param('gbraid') || '';
  if (gclid) guardar('cm_gclid', gclid);
  var utm = param('utm_campaign') || param('campaign') || '';
  if (utm) guardar('cm_campana', utm);

  /* ── La marca, LEÍDA ──────────────────────────────────────────────
     `cm_origen` es la cookie que escribe el guion de atribución del tema;
     es la misma llave que usan las dos landings. Si todavía no está —el
     tema la escribe al ver el primer enlace marcado—, se saca del propio
     mensaje del botón, que es donde acaba de dejarla. Y si no hay
     ninguna de las dos, se dice que no se sabe en vez de callarse. */
  function marcaDeUnEnlace() {
    var as = document.querySelectorAll('a[href*="wa.me"], a[href*="whatsapp.com"]');
    for (var i = 0; i < as.length; i++) {
      var m = String(as[i].getAttribute('href') || '').match(/%23cm-([a-z0-9._-]+)|#cm-([a-z0-9._-]+)/i);
      if (m) return (m[1] || m[2]).toLowerCase().replace(/[.\-_]+$/, '');
    }
    return '';
  }
  function marca() { return leer('cm_origen') || marcaDeUnEnlace() || 'web-desconocido'; }

  /* ── 1. FAQ: acordeón de apertura única ──────────────────────────── */
  var faqs = document.querySelectorAll('[data-cm-faq] .cm-faq__item');
  for (var i = 0; i < faqs.length; i++) {
    faqs[i].addEventListener('toggle', function () {
      if (!this.open) return;
      for (var j = 0; j < faqs.length; j++) {
        if (faqs[j] !== this) faqs[j].open = false;
      }
    });
  }

  /* ── 2. Las etiquetas, cuando alguien toca algo ───────────────────
     Los eventos se encolan —`dataLayer` para Google, `fbq.queue` para
     Meta— desde el primer momento y se procesan cuando llega el guion,
     así que no se pierde ninguna conversión por cargar tarde y quien no
     toca nada no descarga 140 KB.

     Y ojo con la tienda: el guion de atribución del tema, el canal de
     Google y la app de Meta de Shopify pueden haber cargado ya lo suyo,
     así que `gtag`/`fbq` YA EXISTEN. Entonces esto no vuelve a inyectar
     el guion ni repite el `init` —eso contaría dos PageView por visita—:
     se limita a añadir la cuenta de GA4, que es la única que el tema no
     configura. */
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== 'function') {
    window.gtag = function () { window.dataLayer.push(arguments); };
  }
  var gtag = window.gtag;

  var pedidoGtag = false;
  function cargarGtag() {
    if (pedidoGtag || !valido(C.ga4_id)) return;
    pedidoGtag = true;
    gtag('js', new Date());
    gtag('config', C.ga4_id);
    if (document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) return;
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + C.ga4_id;
    document.head.appendChild(s);
  }

  var pedidoMeta = false;
  function cargarMeta() {
    if (pedidoMeta) return;
    pedidoMeta = true;
    if (typeof window.fbq === 'function') return;   // ya lo cargó la tienda
    if (!valido(C.meta_pixel)) return;
    var f = window.fbq = function () {
      f.callMethod ? f.callMethod.apply(f, arguments) : f.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = f;
    f.push = f; f.loaded = true; f.version = '2.0'; f.queue = [];
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(s);
    window.fbq('init', C.meta_pixel);
    window.fbq('track', 'PageView');
  }

  function cargarTodo() { cargarGtag(); cargarMeta(); }
  ['pointerdown', 'touchstart', 'keydown', 'scroll'].forEach(function (e) {
    addEventListener(e, cargarTodo, { once: true, passive: true });
  });
  setTimeout(cargarTodo, 5000);

  /* ── 3. El clic de WhatsApp, que es LA conversión de esta página ──
     Tres destinos y ninguno sustituye a los otros: Google Ads para que el
     anuncio aprenda, GA4 para ver qué sección trae gente, y Meta. El
     cuarto —el ERP— no se avisa desde acá: viaja en el texto del mensaje
     y llega solo cuando la persona escribe de verdad. Por eso es el único
     de los cuatro que no cuenta a quien pulsa y se arrepiente.

     Los nombres de evento son los MISMOS que en `landing-camas` y
     `landing-sillas`, a propósito: un informe que hay que leer tres veces
     con tres vocabularios no se lee ninguna. */
  document.addEventListener('click', function (ev) {
    var el = ev.target;
    if (el && el.nodeType === 3) el = el.parentElement;
    if (!el || !el.closest) return;
    var a = el.closest('[data-cm-cta]');
    if (!a) return;

    cargarTodo();
    var datos = {
      origen: a.getAttribute('data-cm-cta') || 'landing',
      marca: marca(),
      campana: leer('cm_campana') || '(directo)'
    };
    try {
      /* La conversión de Google Ads NO se manda desde aquí: la manda el
         guion de atribución del tema en este mismo clic. Ver arriba. */
      gtag('event', 'contacto_whatsapp', datos);
      /* El nombre que GA4 reconoce como generación de prospecto. Va
         ADEMÁS del de arriba, no en su lugar: el nuestro dice de qué
         sección salió y ése es el que se mira en el informe. */
      gtag('event', 'generate_lead', { method: 'whatsapp', origen: datos.origen });
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'Lead', {
          content_name: datos.origen,
          content_category: C.producto || 'landing',
          source: datos.marca
        });
      }
    } catch (e) {}
  }, true);
})();

/* ═══════════════════════════════════════════════════════════════════════
   Lo propio de una landing con DOS acciones de conversión (el sillón 9188).

   Va aparte del bloque de arriba y con su propio cerrojo porque el de arriba
   es común a todas las landings; esto sólo hace falta donde además de
   escribir por WhatsApp se puede comprar.
   ═══════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.__cmCompra) return;
  window.__cmCompra = true;

  var C = window.CM_CONFIG || {};

  /* ── El botón de comprar ─────────────────────────────────────────
     Es un <form> que postea a /cart/add, no un enlace: así Shopify añade
     al carrito de verdad y respeta el stock. El evento se manda en el
     `submit` y NO se toca la navegación — el mismo motivo que con
     WhatsApp: si esta página decidiera navegar por su cuenta, se saltaría
     lo que el tema hace en medio. */
  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (!f || !f.matches || !f.matches('[data-cm-compra]')) return;
    if (typeof window.fbq !== 'function') return;
    try {
      window.fbq('track', 'InitiateCheckout', {
        content_name: f.getAttribute('data-cm-compra') || 'compra',
        content_category: C.producto || 'landing',
        content_type: 'product'
      });
    } catch (e) {}
  }, true);

  /* ── El video, con fachada ───────────────────────────────────────
     Hasta que alguien pulsa no se pide nada a YouTube: el reproductor son
     cientos de kilobytes y esta página se abre desde un anuncio, con el
     teléfono en la calle. Al pulsar se cambia la miniatura por el iframe,
     ya con `autoplay` porque el gesto ya lo dio la persona. */
  var botones = document.querySelectorAll('[data-cm-video]');
  for (var i = 0; i < botones.length; i++) {
    botones[i].addEventListener('click', function () {
      var id = this.getAttribute('data-cm-video');
      if (!id) return;
      var marco = document.createElement('iframe');
      marco.src = 'https://www.youtube-nocookie.com/embed/' + id +
                  '?autoplay=1&rel=0&modestbranding=1';
      marco.title = this.getAttribute('data-cm-titulo') || 'Video';
      marco.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      marco.allowFullscreen = true;
      this.parentNode.replaceChild(marco, this);
    });
  }
})();
